import logo from '../logo.png';
import { Grid } from '@mui/material';

const Logo = ({ height = 'auto', width = 'auto' }) => {
  return (
    <Grid container justifyContent="center">
      <Grid item textAlign="center">
        <img style={{ height, width }} alt="" src={logo} />
      </Grid>
    </Grid>
  );
};

export default Logo;
